module.exports = __webpack_public_path__ + "static/media/r6s1.321a1198.jpg";